module.exports = __webpack_public_path__ + "static/media/auto-icon copy.6fa79492.svg";